import type { ReactElement } from 'react';

type PropsFormRow = {
    label: string;
    children: ReactElement;
    htmlFor?: string;
};

export const FormRow: React.FC<PropsFormRow> = ({ children, htmlFor, label }) => {
    return (
        <div className="flex items-center gap-2">
            <label htmlFor={htmlFor} className="w-48 shrink-0 text-sm text-midnight">
                {label}
            </label>
            {children}
        </div>
    );
};
